import React, { useState } from 'react';
import Button from '../Button';
import Div from '../Div';

const ShowHideText = (props: any) => {
  const { children } = props;
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <Div className="flex flex-col gap-s2 items-start">
      <Div className={`${isVisible ? 'block' : 'hidden'} flex flex-col gap-s2`}>{children}</Div>
      <Button theme="none" onClick={toggleVisibility} className="!p-s1 text-button-small">
        {isVisible ? 'View Less' : 'View More'}
      </Button>
    </Div>
  );
};

export default ShowHideText;
